<action class="w-12 button"
        [class.is-disabled]="isDisabled"
        [status]="status"
        (click)="submit()"
        cy-basketAddButton>
    {{ 'Add to bag' | translate }}
</action>
@if(displayWarrning) {
<p class="p3 col-6 m-t-1 center">{{"Some of items aren't in stock" | translate}}</p>
}
<result class="block"
        [status]="status"></result>
